import * as packageJSON from '../../package.json';

const { version } = packageJSON;

export const environment = {
  production: false,
  staging: true,
  authToken: 'auth-token',
  apiVersion: '3.1',
  clientVersion: 'angular_admin_' + version,
  buildVersion: '1.0.2',
  userInfo: 'userInfo',
  baseUrlBE: 'https://dev-api.umag.kz',
  partnersUrl: 'https://dev-partner.umag.kz',
  amplitude: {
    API_KEY: ''
  },
};
